module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-2500-Classes-Active-3fd40544dd98459a252d0ac25b7d89f5.png";